import { TOGGLE_BODY_SCROLL, TOGGLE_LOADING } from "./constants";

const initialState = {
  scroll: true,
  isLoading: false
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case TOGGLE_BODY_SCROLL:
      return {
        ...state,
        scroll: payload
      };
    case TOGGLE_LOADING:
      return {
        ...state,
        isLoading: !state.isLoading
      };

    default:
      return state;
  }
};
